import React, { useState } from 'react'
import { MapContainer, TileLayer, Marker, Popup, useMapEvent } from 'react-leaflet'


//map component will be controlled by lat and long slice of state
//when map on screen is clicked on formValues.lat and formValues.long update
const  Map = (props) => {
    const { formValues, updateLocation, selectedPosition } = props
    
    const Markers = () => {
        useMapEvent({
            click(e) {                                
                updateLocation([e.latlng.lat, e.latlng.lng]);
            },            
        })
        return (
            selectedPosition ? 
                <Marker           
                key={selectedPosition[0]}
                position={selectedPosition}
                interactive={false} 
                />
            : null
        )       
    }




    return(
        <MapContainer center={ selectedPosition } zoom={10}>
            <Markers  />
            <TileLayer
                attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
        </MapContainer >
    )
}

export default Map


